<template>
    <div id="mobile-menu" class="fixed-bottom d-block d-lg-none bg-white py-2 mobile-menu-wrapper">
        <div class="d-flex mobile-menu">
            <div class="w-20 mobile-menu-item">
                <router-link to="/ads" class="link-dark mobile-menu-link text-center" :class="getRoute() === 'Ad' || getRoute() === 'NewAdOne' || getRoute() === 'NewAdTwo' ||  getRoute() === 'NewAdThree' ? 'active' : ''">
                    <div class="menu-item">
                        <div class="svg-wrapper mb-2">
                            <svg xmlns="http://www.w3.org/2000/svg" width="23" height="23" fill="currentColor"
                                class="bi bi-grid" viewBox="0 0 16 16">
                                <path
                                    d="M1 2.5A1.5 1.5 0 0 1 2.5 1h3A1.5 1.5 0 0 1 7 2.5v3A1.5 1.5 0 0 1 5.5 7h-3A1.5 1.5 0 0 1 1 5.5zM2.5 2a.5.5 0 0 0-.5.5v3a.5.5 0 0 0 .5.5h3a.5.5 0 0 0 .5-.5v-3a.5.5 0 0 0-.5-.5zm6.5.5A1.5 1.5 0 0 1 10.5 1h3A1.5 1.5 0 0 1 15 2.5v3A1.5 1.5 0 0 1 13.5 7h-3A1.5 1.5 0 0 1 9 5.5zm1.5-.5a.5.5 0 0 0-.5.5v3a.5.5 0 0 0 .5.5h3a.5.5 0 0 0 .5-.5v-3a.5.5 0 0 0-.5-.5zM1 10.5A1.5 1.5 0 0 1 2.5 9h3A1.5 1.5 0 0 1 7 10.5v3A1.5 1.5 0 0 1 5.5 15h-3A1.5 1.5 0 0 1 1 13.5zm1.5-.5a.5.5 0 0 0-.5.5v3a.5.5 0 0 0 .5.5h3a.5.5 0 0 0 .5-.5v-3a.5.5 0 0 0-.5-.5zm6.5.5A1.5 1.5 0 0 1 10.5 9h3a1.5 1.5 0 0 1 1.5 1.5v3a1.5 1.5 0 0 1-1.5 1.5h-3A1.5 1.5 0 0 1 9 13.5zm1.5-.5a.5.5 0 0 0-.5.5v3a.5.5 0 0 0 .5.5h3a.5.5 0 0 0 .5-.5v-3a.5.5 0 0 0-.5-.5z" />
                            </svg>
                        </div>
                        <p class="text-small mb-0">Annunci</p>
                    </div>
                </router-link>
            </div>
            <div class="w-20 mobile-menu-item">
                <router-link to="/requests" class="link-dark mobile-menu-link text-center" :class="getRoute() === 'MessagePg' ? 'active' : ''">
                    <div class="menu-item">
                        <div class="svg-wrapper mb-2">
                            <svg xmlns="http://www.w3.org/2000/svg" width="23" height="23" fill="currentColor"
                                class="bi bi-chat-left" viewBox="0 0 16 16">
                                <path
                                    d="M14 1a1 1 0 0 1 1 1v8a1 1 0 0 1-1 1H4.414A2 2 0 0 0 3 11.586l-2 2V2a1 1 0 0 1 1-1h12zM2 0a2 2 0 0 0-2 2v12.793a.5.5 0 0 0 .854.353l2.853-2.853A1 1 0 0 1 4.414 12H14a2 2 0 0 0 2-2V2a2 2 0 0 0-2-2H2z" />
                            </svg>
                        </div>
                        <p class="text-small mb-0">Posta</p>
                    </div>
                </router-link>
            </div>
            <div class="w-20 mobile-menu-item">
                <router-link to="/stats" class="link-dark mobile-menu-link text-center">
                    <div class="menu-item">

                        <div class="svg-wrapper mb-2">
                            <svg xmlns="http://www.w3.org/2000/svg" width="23" height="23" fill="currentColor"
                                class="bi bi-graph-up-arrow" viewBox="0 0 16 16">
                                <path fill-rule="evenodd"
                                    d="M0 0h1v15h15v1H0zm10 3.5a.5.5 0 0 1 .5-.5h4a.5.5 0 0 1 .5.5v4a.5.5 0 0 1-1 0V4.9l-3.613 4.417a.5.5 0 0 1-.74.037L7.06 6.767l-3.656 5.027a.5.5 0 0 1-.808-.588l4-5.5a.5.5 0 0 1 .758-.06l2.609 2.61L13.445 4H10.5a.5.5 0 0 1-.5-.5" />
                            </svg>
                        </div>
                        <p class="text-small mb-0">Statistiche</p>
                    </div>
                </router-link>
            </div>
            <div class="w-20 mobile-menu-item">
                <router-link to="/logistics" class="link-dark mobile-menu-link text-center">
                    <div class="menu-item">
                        <div class="svg-wrapper mb-2">
                            <svg xmlns="http://www.w3.org/2000/svg" width="23" height="23" fill="currentColor"
                                class="bi bi-truck" viewBox="0 -2 16 16">
                                <path
                                    d="M0 3.5A1.5 1.5 0 0 1 1.5 2h9A1.5 1.5 0 0 1 12 3.5V5h1.02a1.5 1.5 0 0 1 1.17.563l1.481 1.85a1.5 1.5 0 0 1 .329.938V10.5a1.5 1.5 0 0 1-1.5 1.5H14a2 2 0 1 1-4 0H5a2 2 0 1 1-3.998-.085A1.5 1.5 0 0 1 0 10.5zm1.294 7.456A2 2 0 0 1 4.732 11h5.536a2 2 0 0 1 .732-.732V3.5a.5.5 0 0 0-.5-.5h-9a.5.5 0 0 0-.5.5v7a.5.5 0 0 0 .294.456M12 10a2 2 0 0 1 1.732 1h.768a.5.5 0 0 0 .5-.5V8.35a.5.5 0 0 0-.11-.312l-1.48-1.85A.5.5 0 0 0 13.02 6H12zm-9 1a1 1 0 1 0 0 2 1 1 0 0 0 0-2m9 0a1 1 0 1 0 0 2 1 1 0 0 0 0-2" />
                            </svg>
                        </div>
                        <p class="text-small mb-0">Logistica</p>
                    </div>
                </router-link>
            </div>
            <div class="w-20 mobile-menu-item">
                <router-link to="/profile" class="link-dark mobile-menu-link text-center">
                    <div class="menu-item">

                        <div class="svg-wrapper mb-2">
                            <svg xmlns="http://www.w3.org/2000/svg" width="23" height="23" fill="currentColor"
                                class="bi bi-person" viewBox="0 0 16 16">
                                <path
                                    d="M8 8a3 3 0 1 0 0-6 3 3 0 0 0 0 6m2-3a2 2 0 1 1-4 0 2 2 0 0 1 4 0m4 8c0 1-1 1-1 1H3s-1 0-1-1 1-4 6-4 6 3 6 4m-1-.004c-.001-.246-.154-.986-.832-1.664C11.516 10.68 10.289 10 8 10s-3.516.68-4.168 1.332c-.678.678-.83 1.418-.832 1.664z" />
                            </svg>
                        </div>
                        <p class="text-small mb-0">Profilo</p>
                    </div>
                </router-link>
            </div>

        </div>

    </div>
</template>
<script>

export default {
    name: "MobileMenu",
    methods: {
        getRoute() {
            return this.$route.name;
        }
    }
}
</script>
<style scoped>
.mobile-menu-wrapper {
    border-top: 1px solid #252321;
}


.mobile-menu p {
    font-size: 10px;
    font-weight: 600;
}

.mobile-menu-link.active p {
    color: #EA1E28;
}
</style>